import React, { useEffect, useMemo, useState } from 'react';
import { deletePage, loadPages } from '../utils/Network';
import SelectLanguage from '../components/SelectLanguage';
import LanguageName from '../components/LanguageName';
import { getRange } from '../utils';

export default function PagesContent({ page, urlParams }) {
    const currentPage = Number(page) || 1;
    const filterQuery = useMemo(() => window.location.search, []);
    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);
    const [all_pages, setAllPages] = useState(null);
    const [pages, setPages] = useState(null);
    const [pages_count, setPagesCount] = useState(null);
    const [show_delete, setShowDelete] = useState(false);
    const [filter_title, setFilterTitle] = useState('');
    const [filter_language, setFilterLanguage] = useState(null);

    useEffect(() => {
        setPageLoading(true);
        getPages();
        setFilterTitle(urlParams.get('title'));
        setFilterLanguage(urlParams.get('language'));
    }, []);

    function getPages() {
        loadPages(filterQuery, currentPage).then((data) => {
            if (data.results) {
                setAllPages(data.results);
            }
            const totalCount = Number(data.count) || 0;
            setPagesCount(totalCount);
            if (totalCount > 0) {
                const pageCount =
                    totalCount % 10 === 0 ? parseInt(totalCount / 10, 10) : parseInt(totalCount / 10, 10) + 1;
                setPages(getRange(1, pageCount));
            } else {
                setPages([]);
            }
            setPageLoading(false);
        });
    }

    const handleDelete = (id) => {
        setLoading(id);
        deletePage(id).then(() => {
            getPages();
        });
    };

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete);
    };

    const onValue = (value, name) => {
        switch (name) {
            case 'language':
                setFilterLanguage(value);
                break;
            default:
                break;
        }
    };

    const onChange = (e) => {
        switch (e.target.name) {
            case 'title':
                setFilterTitle(e.target.value);
                break;
            default:
                break;
        }
    };

    const totalPages = pages?.length || 0;
    const canGoPrev = totalPages > 0 && currentPage > 1;
    const canGoNext = totalPages > 0 && currentPage < totalPages;
    const queryString = urlParams.toString();

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <h3 className="box-title mb-10">
                        <span className="sr-only">Pages</span>
                    </h3>
                    <ol className="breadcrumb">
                        <li>
                            <a href="/cms">
                                <i className="fa fa-dashboard"></i> Home
                            </a>
                        </li>
                        <li className="active">Pages</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row users-filter-page-row">
                            <div className="col-md-12 users-filter-page-col">
                                <div className="box talent-page-box">
                                    <div className="box-header with-border">
                                        <h3
                                            className="box-title mt-5"
                                            style={{
                                                color: '#ccc',
                                                letterSpacing: '0.08em',
                                                textTransform: 'uppercase',
                                                fontSize: '13px',
                                            }}
                                        >
                                            All pages
                                            {pages_count != null && (
                                                <span style={{ opacity: 0.75, marginLeft: '0.35em' }}>
                                                    ({pages_count})
                                                </span>
                                            )}
                                        </h3>
                                        <a href="/cms/page" title="Add New" className="btn btn-cm pull-right">
                                            <i className="fa fa-plus"></i>
                                        </a>
                                        <button
                                            type="button"
                                            title="Show Delete Button"
                                            className="btn btn-cm margin-r-5 pull-right"
                                            onClick={showDelete}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </div>
                                    <div className="box-body no-padding">
                                        <form action="" method="get">
                                            <table
                                                id="example1"
                                                className={`table table-striped cms-list-table mb-0${pageloading ? ' opacity-70' : ''}`}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                name="title"
                                                                className="form-control"
                                                                type="text"
                                                                value={filter_title || ''}
                                                                onChange={onChange}
                                                            />
                                                        </th>
                                                        <th>
                                                            <SelectLanguage value={filter_language} callback={onValue} border="1" />
                                                            <input type="hidden" name="language" value={filter_language || ''} />
                                                        </th>
                                                        <th></th>
                                                        <th style={{ width: 160 }}>
                                                            <button type="submit" className="btn btn-cm pull-right">
                                                                <i className="fa fa-filter"></i>
                                                            </button>
                                                            {(filter_language || filter_title) && (
                                                                <a href="/cms/pages" className="btn btn-cm pull-right mr-1">
                                                                    Cancel
                                                                </a>
                                                            )}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Language</th>
                                                        <th>Date</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {all_pages &&
                                                        all_pages.map((item) => (
                                                            <tr key={item.id} className={loading === item.id ? 'loading' : ''}>
                                                                <td>
                                                                    <div className="img-container">
                                                                        <a href={`/cms/page/${item.id}`}>
                                                                            <img
                                                                                src={
                                                                                    item.gallery_image
                                                                                        ? item.gallery_image.image
                                                                                        : '/images/default.png'
                                                                                }
                                                                                className="pull-left img-list height-50 margin-r-10"
                                                                                alt=""
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                    <p className="mb-0 kfont">
                                                                        <a href={`/cms/page/${item.id}`} className="link-color">
                                                                            {item.title}
                                                                        </a>
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                    <a href={`/cms/pages?language=${item.language}`}>
                                                                        <LanguageName id={item.language} />
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    {item.created_at.split('T')[0]}
                                                                    <br />
                                                                    {item.created_at.split('T')[1].split('.')[0]}
                                                                </td>
                                                                <td>
                                                                    <div className="btn-group cms-row-actions">
                                                                        {show_delete && (
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    if (
                                                                                        window.confirm(
                                                                                            'Are you sure you wish to delete this item?'
                                                                                        )
                                                                                    ) {
                                                                                        handleDelete(item.id);
                                                                                    }
                                                                                }}
                                                                                className="btn btn-default btn-sm cms-row-action-btn cms-row-action-btn-danger"
                                                                            >
                                                                                <i className="fa fa-trash"></i>
                                                                            </button>
                                                                        )}
                                                                        <a
                                                                            href={`/cms/page/${item.id}`}
                                                                            className="btn btn-default btn-sm cms-row-action-btn"
                                                                        >
                                                                            <i className="fa fa-edit"></i>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Language</th>
                                                        <th>Date</th>
                                                        <th></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </form>
                                        {!all_pages?.length && !pageloading && (
                                            <div className="padding-10 text-muted">No pages found.</div>
                                        )}
                                    </div>
                                </div>
                                <ul className="pagination cms-pagination m-0 float-right">
                                    <li className={`page-item${!canGoPrev ? ' disabled' : ''}`}>
                                        <a
                                            className="page-link"
                                            href={canGoPrev ? `/cms/pages/${currentPage - 1}${queryString ? `?${queryString}` : ''}` : '#'}
                                            onClick={!canGoPrev ? (e) => e.preventDefault() : undefined}
                                            aria-disabled={!canGoPrev}
                                        >
                                            «
                                        </a>
                                    </li>
                                    {pages &&
                                        pages.map((page_number) => (
                                            <li key={page_number} className="page-item">
                                                <a
                                                    className={page_number === currentPage ? 'page-link active' : 'page-link'}
                                                    href={`/cms/pages/${page_number}${queryString ? `?${queryString}` : ''}`}
                                                >
                                                    {page_number}
                                                </a>
                                            </li>
                                        ))}
                                    <li className={`page-item${!canGoNext ? ' disabled' : ''}`}>
                                        <a
                                            className="page-link"
                                            href={canGoNext ? `/cms/pages/${currentPage + 1}${queryString ? `?${queryString}` : ''}` : '#'}
                                            onClick={!canGoNext ? (e) => e.preventDefault() : undefined}
                                            aria-disabled={!canGoNext}
                                        >
                                            »
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
